export default __webpack_public_path__ + "static/media/reporting_status_icon.6ee22064.svg";